import { PAGE_TYPE } from "enums";
import { getLanguageValue } from "locales/i18n";
import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const UnSubscribeEmailComponent = (props: any) => {
  const { email, setEmail, unSubscribedEmail } = props;

  return (
    <main className="flex flex-col items-center justify-center min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
        <h2 className="mt-6 text-center text-2xl font-extrabold text-gray-900">
          {getLanguageValue(PAGE_TYPE.COMMON, "unSubscribeEmail.txtContent")}
        </h2>

        <div className="space-y-6">
          <div className="flex justify-center">
            <div className="text-4xl text-gray-400">
              <i className="fas fa-envelope-slash"></i>
            </div>
          </div>

          <p className="text-center text-sm text-gray-600">
            이메일 수신을 거부하시려면 아래에 이메일 주소를 입력해주세요.
          </p>

          <div className="mt-4">
            <div className="mb-4">
              <input
                id="email-input"
                type="email"
                placeholder={getLanguageValue(
                  PAGE_TYPE.COMMON,
                  "unSubscribeEmail.emailPlaceholder"
                )}
                value={email}
                onChange={(evt) => setEmail(evt.target.value)}
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              />
            </div>
          </div>

          <div className="mt-6">
            <button
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#CF3688]   hover:bg-[#a62d6d] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={unSubscribedEmail}
              disabled={!email}
            >
              {getLanguageValue(
                PAGE_TYPE.COMMON,
                "unSubscribeEmail.btnRequestUnSubscribe"
              )}
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};
export default UnSubscribeEmailComponent;
